import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { applyMeta, metaFor } from '../lib/seo';

// Keeps the tab title, the description and the link-preview tags in step
// with the page being shown. Renders nothing.
export default function PageMeta() {
  const { pathname } = useLocation();
  const { i18n } = useTranslation();
  const lang = i18n.language;
  useEffect(() => { applyMeta(document, metaFor(pathname, lang)); }, [pathname, lang]);
  return null;
}
